import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { PalletsEffects } from './effects/pallets.effects';
import { PALLETS_FEATURE_KEY } from './keys';
import { palletsReducer } from './reducers/pallets.reducer';

export function providePalletsStore(): EnvironmentProviders[] {
    return [provideState(PALLETS_FEATURE_KEY, palletsReducer), provideEffects(PalletsEffects)];
}
